interface Props {
  className?: string;
}
export const EmptyState = ({ className }: Props) => (
  <svg
    width="1037"
    height="906"
    viewBox="0 0 1037 906"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M255.151 580.277C255.43 581.391 255.779 582.575 256.197 583.829L257.034 587.172C257.28 588.058 257.42 588.969 257.453 589.888C257.517 593.579 256.419 597.198 254.314 600.231C252.29 603.171 249.454 605.458 246.152 606.813C244.832 606.956 243.504 607.026 242.176 607.022C240.926 607.169 239.668 607.239 238.409 607.231H234.433L201.783 607.649V642.541C201.783 647.695 201.888 652.884 202.097 658.107C202.306 663.33 202.551 668.03 202.83 672.207C203.109 677.222 203.458 682.027 203.877 686.624H173.735L174.363 678.475C174.503 675.271 174.643 670.918 174.782 665.416C174.921 659.914 174.991 652.566 174.991 643.373V611.409C172.828 613.416 169.989 614.535 167.038 614.543C164.861 614.596 162.716 614.016 160.864 612.871C159.079 611.712 157.605 610.132 156.573 608.271L132.923 607.017C128.436 605.974 124.402 603.521 121.412 600.017C118.363 596.522 116.722 592.018 116.807 587.381C116.801 586.609 116.871 585.839 117.016 585.081C117.161 584.367 117.371 583.668 117.644 582.992L122.877 570.874C123.139 567.866 124.03 564.948 125.493 562.307C126.924 559.702 128.801 557.368 131.039 555.412L163.898 494.612H164.107C166.581 489.972 169.758 485.743 173.526 482.075C177.153 478.592 181.828 476.851 187.549 476.851C192.346 476.784 197.052 478.168 201.049 480.821C204.954 483.38 208.043 487.006 209.949 491.268L236.32 542.876C241.034 544.527 245.125 547.591 248.035 551.651C251.102 555.825 252.717 560.889 252.635 566.068C252.609 568.471 252.257 570.86 251.588 573.168L255.151 580.277Z"
      fill="url(#paint0_linear_5_3)"
    />
    <path
      d="M994.137 580.277C994.416 581.391 994.764 582.575 995.183 583.829L996.02 587.172C996.266 588.058 996.406 588.969 996.439 589.888C996.503 593.579 995.405 597.198 993.3 600.231C991.276 603.171 988.44 605.458 985.138 606.813C983.818 606.956 982.49 607.026 981.162 607.022C979.911 607.169 978.652 607.239 977.393 607.231H973.417L940.768 607.649V642.541C940.768 647.695 940.873 652.884 941.083 658.107C941.293 663.33 941.537 668.03 941.815 672.207C942.094 677.222 942.442 682.027 942.861 686.624H912.722L913.349 678.475C913.49 675.271 913.629 670.918 913.768 665.416C913.907 659.914 913.977 652.566 913.978 643.373V611.409C911.815 613.417 908.974 614.536 906.023 614.543C903.846 614.596 901.701 614.015 899.849 612.871C898.064 611.712 896.592 610.132 895.56 608.271L871.908 607.017C867.422 605.974 863.388 603.521 860.399 600.017C857.35 596.522 855.709 592.018 855.794 587.381C855.788 586.609 855.858 585.839 856.004 585.081C856.148 584.367 856.358 583.667 856.631 582.992L861.863 570.873C862.124 567.865 863.017 564.946 864.481 562.306C865.912 559.701 867.789 557.367 870.026 555.411L902.885 494.611H903.095C905.568 489.971 908.745 485.742 912.513 482.075C916.141 478.592 920.815 476.851 926.536 476.851C931.333 476.784 936.039 478.168 940.036 480.821C943.938 483.382 947.025 487.007 948.93 491.268L975.3 542.876C980.016 544.526 984.109 547.59 987.021 551.651C990.09 555.824 991.708 560.888 991.627 566.068C991.601 568.471 991.249 570.859 990.581 573.168L994.137 580.277Z"
      fill="url(#paint1_linear_5_3)"
    />
    <path
      d="M906.443 603.244C906.66 604.118 906.931 605.046 907.258 606.029L907.911 608.65C908.102 609.345 908.212 610.06 908.238 610.78C908.289 613.673 907.433 616.509 905.79 618.89C904.216 621.192 902.005 622.986 899.428 624.051C898.399 624.163 897.364 624.218 896.328 624.215C895.353 624.33 894.372 624.385 893.391 624.379H890.291L864.836 624.707V652.066C864.836 656.107 864.917 660.176 865.079 664.271C865.241 668.366 865.432 672.053 865.651 675.33C865.868 679.263 866.139 683.03 866.466 686.63H842.966L843.455 680.241C843.564 677.729 843.673 674.316 843.782 670.002C843.891 665.688 843.945 659.927 843.946 652.718V627.65C842.264 629.222 840.049 630.1 837.746 630.107C836.048 630.149 834.374 629.693 832.931 628.796C831.539 627.887 830.391 626.651 829.587 625.196L811.148 624.213C807.646 623.393 804.499 621.469 802.173 618.725C799.793 615.978 798.515 612.448 798.583 608.814C798.579 608.21 798.633 607.607 798.745 607.014C798.859 606.454 799.024 605.906 799.236 605.376L803.315 595.876C803.519 593.519 804.214 591.231 805.356 589.159C806.47 587.115 807.935 585.282 809.682 583.744L835.301 536.07H835.463C837.39 532.434 839.867 529.118 842.808 526.24C844.266 524.865 845.984 523.795 847.86 523.092C849.737 522.389 851.735 522.067 853.737 522.144C857.48 522.092 861.15 523.178 864.262 525.257C867.309 527.268 869.716 530.111 871.197 533.448L891.756 573.914C895.439 575.212 898.631 577.615 900.896 580.795C903.289 584.071 904.549 588.038 904.486 592.095C904.465 593.98 904.19 595.854 903.668 597.665L906.443 603.244Z"
      fill="url(#paint2_linear_5_3)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504.18 631.799C650.499 631.799 782.258 643.735 874.36 662.799C964.438 663.399 1036.97 690.38 1036.97 723.577C1036.97 749.887 991.411 772.293 927.666 780.755C912.452 785.255 895.327 789.499 876.514 793.442C877.005 795.949 877.251 798.497 877.251 801.051C877.251 858.98 751.313 905.94 595.959 905.94C456.19 905.94 340.231 867.93 318.372 818.117C131.871 803.954 0 769.099 0 728.344C0 675.023 225.729 631.799 504.18 631.799Z"
      fill="#E7EAF0"
    />
    <path
      d="M755.673 459.465L514.906 429.174V549.296L751.827 576.974L755.673 459.465Z"
      fill="#A2ABB9"
    />
    <path
      d="M324.2 468.374L514.877 429.174L514.907 564.233L324.2 603.193V468.374Z"
      fill="#C0C7D2"
    />
    <path
      d="M548.279 520.169L753.288 467.315V717.207L548.279 770.061V520.169Z"
      fill="#A2ABB9"
    />
    <path
      d="M326.583 474.467L550.663 519.159L549.363 770.059L326.583 720.297V474.467Z"
      fill="#C0C7D2"
    />
    <path
      d="M550.663 520.183L324.599 472.083L276.523 560.683L506.423 615.113L550.663 520.183Z"
      fill="#D1D6E2"
    />
    <path
      d="M550.663 519.088L755.877 462.548L808.116 550.54L611.563 615.113L550.663 519.088Z"
      fill="#C0C7D2"
    />
    <path
      d="M331.965 107.291C273.765 190.624 298.485 252.824 406.125 293.891"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M311.937 279.849C331.637 304.326 349.531 316.564 365.62 316.564"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M787.21 0.5C789.846 74.5667 720.239 126.433 578.389 156.1"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M806.128 93.707C771.328 122.874 744.112 137.458 724.48 137.458"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M748.521 263.072C611.539 246.535 525.45 281.812 490.255 368.902"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M328.765 164.531C409.685 177.208 442.808 199.597 428.135 231.698C413.462 263.799 380.338 241.41 328.765 164.531Z"
      fill="url(#paint3_linear_5_3)"
    />
    <path
      d="M619.389 93.708C631.23 51.7913 662.172 37.819 712.215 51.791C710.058 71.019 679.116 84.9913 619.389 93.708Z"
      fill="url(#paint4_linear_5_3)"
    />
    <path
      d="M510.867 399.894C547.821 328.021 599.466 307.555 665.802 338.494C634.86 395.738 583.215 416.205 510.867 399.894Z"
      fill="url(#paint5_linear_5_3)"
    />
    <path
      d="M607.884 115.583C616.938 96.173 628.856 83.7446 643.637 78.298"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M406.125 222.218C423.051 226.14 431.514 242.419 431.514 271.055"
      stroke="#707070"
      strokeLinecap="round"
    />
    <path
      d="M495.023 422.876C508.764 396.649 527.838 383.536 552.244 383.536"
      stroke="#707070"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5_3"
        x1="246.907"
        y1="684.107"
        x2="174.168"
        y2="685.239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0E5EF" stopOpacity="0" />
        <stop offset="1" stopColor="#E0E5EF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5_3"
        x1="985.893"
        y1="684.107"
        x2="913.155"
        y2="685.239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0E5EF" stopOpacity="0" />
        <stop offset="1" stopColor="#E0E5EF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5_3"
        x1="899.467"
        y1="684.656"
        x2="799.699"
        y2="556.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0E5EF" stopOpacity="0" />
        <stop offset="1" stopColor="#E0E5EF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5_3"
        x1="337.396"
        y1="229.286"
        x2="417.455"
        y2="157.013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0C7D2" />
        <stop offset="1" stopColor="#909AA9" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5_3"
        x1="627.186"
        y1="75.8829"
        x2="697.914"
        y2="34.9779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0C7D2" />
        <stop offset="1" stopColor="#909AA9" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5_3"
        x1="523.882"
        y1="375.265"
        x2="641.351"
        y2="305.469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0C7D2" />
        <stop offset="1" stopColor="#909AA9" />
      </linearGradient>
    </defs>
  </svg>
);

export const ErrorState = ({ className }: Props) => {
  return (
    <svg
      width="135"
      height="135"
      viewBox="0 0 135 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M131.496 67.5107C131.496 102.798 102.786 131.499 67.4981 131.499C32.2105 131.499 3.5 102.798 3.5 67.5107C3.5 32.2133 32.2105 3.50281 67.4981 3.50281C102.786 3.50281 131.496 32.2133 131.496 67.5107Z"
        fill="#D6DCE8"
      />
      <path
        d="M127.483 36.7599V99.803C127.483 103.899 124.164 107.217 120.069 107.217H15.279C11.193 107.217 7.85522 103.899 7.85522 99.803V36.7599C7.85522 36.2183 8.2983 35.7753 8.83981 35.7753H126.498C127.049 35.7753 127.483 36.2183 127.483 36.7599Z"
        fill="#F9FAFD"
      />
      <path
        d="M127.492 30.0942V36.7697C127.492 37.3112 127.049 37.7543 126.508 37.7543H8.83981C8.2983 37.7543 7.85522 37.3112 7.85522 36.7697V30.0942C7.85522 25.9983 11.193 22.6704 15.279 22.6704H120.069C124.164 22.6704 127.492 25.9983 127.492 30.0942Z"
        fill="url(#paint0_linear_8_2)"
      />
      <path
        d="M17.719 30.2109C17.719 31.2323 16.8943 32.057 15.8793 32.057C14.8579 32.057 14.0332 31.2323 14.0332 30.2109C14.0332 29.1895 14.8579 28.3648 15.8793 28.3648C16.8943 28.3648 17.719 29.1895 17.719 30.2109ZM24.312 30.2109C24.312 31.2323 23.4873 32.057 22.4723 32.057C21.4509 32.057 20.6262 31.2323 20.6262 30.2109C20.6262 29.1895 21.4509 28.3648 22.4723 28.3648C23.4873 28.3648 24.312 29.1895 24.312 30.2109ZM30.905 30.2109C30.905 31.2323 30.0803 32.057 29.0653 32.057C28.0439 32.057 27.2192 31.2323 27.2192 30.2109C27.2192 29.1895 28.0439 28.3648 29.0653 28.3648C30.0803 28.3648 30.905 29.1895 30.905 30.2109Z"
        fill="white"
      />
      <path
        d="M96.1038 72.3133C96.1038 78.2208 91.299 83.0354 85.3915 83.0354H51.374C44.669 83.0354 39.2144 77.5808 39.2144 70.8659C39.2144 64.1904 44.6296 58.7457 51.3051 58.7063C53.7567 51.0856 60.9245 45.8377 68.9981 45.8377C78.3419 45.8377 86.1299 52.6412 87.4099 61.788C92.4215 62.7431 96.1038 67.1343 96.1038 72.3133Z"
        fill="url(#paint1_linear_8_2)"
      />
      <path
        d="M84.7406 92.6629C84.7406 94.1991 83.4953 95.4444 81.9591 95.4444H53.3586C51.8225 95.4444 50.5771 94.1991 50.5771 92.6629C50.5771 91.1268 51.8225 89.8815 53.3586 89.8815H81.9591C83.4953 89.8815 84.7406 91.1268 84.7406 92.6629Z"
        fill="#D6DCE8"
      />
      <path
        d="M81.9592 96.4444H53.3586C51.2737 96.4444 49.5774 94.748 49.5774 92.6629C49.5774 90.5778 51.2737 88.8815 53.3586 88.8815H81.9592C84.0442 88.8815 85.7405 90.5778 85.7405 92.6629C85.7405 94.748 84.0442 96.4444 81.9592 96.4444ZM53.3586 90.8815C52.3762 90.8815 51.5774 91.6806 51.5774 92.6629C51.5774 93.6452 52.3762 94.4444 53.3586 94.4444H81.9592C82.9416 94.4444 83.7405 93.6452 83.7405 92.6629C83.7405 91.6806 82.9416 90.8815 81.9592 90.8815H53.3586Z"
        fill="#A8B0C3"
      />
      <path
        d="M69.7125 89.8815H53.3586C51.8225 89.8815 50.5771 91.1268 50.5771 92.6629C50.5771 94.1991 51.8225 95.4444 53.3586 95.4444H69.7125V89.8815Z"
        fill="#A8B0C3"
      />
      <path
        d="M61.5784 75.3218C58.6692 73.3965 56.9329 70.1673 56.9329 66.6837C56.9329 60.9717 61.5764 56.3246 67.2844 56.3246C67.8372 56.3246 68.2844 56.7724 68.2844 57.3246C68.2844 57.8769 67.8372 58.3246 67.2844 58.3246C62.679 58.3246 58.9329 62.0745 58.9329 66.6837C58.9329 69.4943 60.3342 72.1002 62.6819 73.6541C63.1428 73.9589 63.2688 74.5794 62.9641 75.04C62.6615 75.4971 62.0422 75.6287 61.5784 75.3218ZM67.2844 77.0358C65.9605 77.0358 65.9619 75.0358 67.2844 75.0358C71.8899 75.0358 75.637 71.289 75.637 66.6837C75.637 64.1791 74.5286 61.8277 72.5959 60.2325C72.1702 59.8808 72.1096 59.2505 72.4612 58.8246C72.8127 58.3991 73.4426 58.338 73.8694 58.69C76.2639 60.6667 77.637 63.5803 77.637 66.6837C77.637 72.3919 72.9924 77.0358 67.2844 77.0358Z"
        fill="white"
      />
      <path
        d="M65.3499 60.1976C65.0716 60.1976 64.7933 60.0814 64.596 59.8542C64.2328 59.4377 64.2767 58.806 64.6937 58.4433L65.9769 57.3263L64.6927 56.205C64.2767 55.8419 64.2337 55.2102 64.597 54.7941C64.9603 54.3776 65.5931 54.3357 66.0072 54.6984L68.1556 56.5739C68.3734 56.764 68.4984 57.0389 68.4984 57.328C68.4984 57.6169 68.3734 57.8917 68.1546 58.0815L66.0062 59.9519C65.8167 60.1167 65.5833 60.1976 65.3499 60.1976ZM68.4857 78.663L66.4642 76.9033C66.0472 76.5406 66.0033 75.909 66.3665 75.4924C66.7298 75.075 67.3617 75.0333 67.7767 75.3947L69.7982 77.1545C70.2152 77.5172 70.2591 78.1488 69.8958 78.5654C69.5353 78.9804 68.9037 79.0269 68.4857 78.663Z"
        fill="white"
      />
      <path
        d="M67.1204 77.149C66.887 77.149 66.6526 77.068 66.4632 76.903L66.3362 76.7924C65.8791 76.3939 65.8798 75.6832 66.3362 75.2851L68.4847 73.4096C68.8997 73.0467 69.5316 73.0887 69.8948 73.5053C70.2581 73.9213 70.2151 74.553 69.7991 74.9162L68.0853 76.4128C68.0472 76.5536 67.9769 76.6883 67.8743 76.8058C67.6771 77.0328 67.3987 77.149 67.1204 77.149Z"
        fill="white"
      />
      <path
        d="M115.146 124.884C115.777 126.423 115.02 128.192 113.481 128.823C111.942 129.455 110.182 128.719 109.551 127.179C108.919 125.64 109.647 123.859 111.186 123.228C112.725 122.597 114.514 123.345 115.146 124.884ZM119.809 119.119C120.211 120.099 119.73 121.225 118.75 121.627C117.77 122.028 116.65 121.56 116.248 120.58C115.846 119.601 116.309 118.467 117.289 118.065C118.269 117.664 119.408 118.14 119.809 119.119ZM22.4134 11.5409C23.0448 13.0802 22.288 14.8486 20.7489 15.48C19.2097 16.1114 17.4497 15.3754 16.8182 13.8362C16.1868 12.297 16.9144 10.5163 18.4536 9.88485C19.9927 9.25344 21.782 10.0017 22.4134 11.5409ZM27.077 5.77634C27.4789 6.75606 26.9972 7.88161 26.0176 8.28349C25.038 8.68536 23.9178 8.21695 23.5159 7.23723C23.114 6.2576 23.5771 5.1242 24.5567 4.72232C25.5363 4.32045 26.6752 4.79671 27.077 5.77634Z"
        fill="#D6DCE8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8_2"
          x1="67.7569"
          y1="37.388"
          x2="67.4979"
          y2="24.943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#989FB0" />
          <stop offset="1" stopColor="#AAB2C5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8_2"
          x1="66.1559"
          y1="51.665"
          x2="68.3189"
          y2="80.374"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#989FB0" />
          <stop offset="1" stopColor="#AAB2C5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
